export const MIN_BAR_CHART_HEIGHT = 500;
export const MAX_CORRECT_BINS = 50;

export const canvasMargin = {
  top: 20,
  left: 100,
  right: 20,
  bottom: 20
};

export const barsMargin = {
  top: 0,
  right: 0,

  left: 20,
  bottom: 20
};

export const tooltipLeftOffset = 25;
export const tooltipTopOffset = 35;
